/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate cryptographic hashes (SHA-1, SHA-256, SHA-384, SHA-512) of any text. Hashing runs in your browser with the Web Crypto API.`)
};

const es_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera hash criptográficos (SHA-1, SHA-256, SHA-384, SHA-512) de cualquier texto. El hash se calcula en tu navegador con la Web Crypto API.`)
};

const de_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie kryptografische Hashes (SHA-1, SHA-256, SHA-384, SHA-512) aus beliebigem Text. Das Hashing läuft in Ihrem Browser mit der Web Crypto API.`)
};

const nl_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer cryptografische hashes (SHA-1, SHA-256, SHA-384, SHA-512) van elke tekst. Hashing wordt in uw browser uitgevoerd met de Web Crypto API.`)
};

const fr_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez des hash cryptographiques (SHA-1, SHA-256, SHA-384, SHA-512) de n'importe quel texte. Le hachage s'exécute dans votre navigateur avec l'API Web Crypto.`)
};

const it_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera hash crittografici (SHA-1, SHA-256, SHA-384, SHA-512) da qualsiasi testo. L'hashing viene eseguito nel tuo browser con l'API Web Crypto.`)
};

const pt_br2_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere hashes criptográficos (SHA-1, SHA-256, SHA-384, SHA-512) de qualquer texto. O hash é executado no seu navegador com a Web Crypto API.`)
};

const pt_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere hashes criptográficos (SHA-1, SHA-256, SHA-384, SHA-512) de qualquer texto. O hashing funciona no seu navegador com a Web Crypto API.`)
};

const ja_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のテキストの暗号ハッシュ(SHA-1、SHA-256、SHA-384、SHA-512)を生成します。ハッシング処理はWeb Crypto APIを使用してブラウザで実行されます。`)
};

const zh_hg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成任意文本的加密哈希值（SHA-1、SHA-256、SHA-384、SHA-512）。哈希计算通过 Web Crypto API 在浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_intro", locale)
	if (locale === "en") return en_hg_intro(inputs)
	if (locale === "es") return es_hg_intro(inputs)
	if (locale === "de") return de_hg_intro(inputs)
	if (locale === "nl") return nl_hg_intro(inputs)
	if (locale === "fr") return fr_hg_intro(inputs)
	if (locale === "it") return it_hg_intro(inputs)
	if (locale === "pt-BR") return pt_br2_hg_intro(inputs)
	if (locale === "pt") return pt_hg_intro(inputs)
	if (locale === "ja") return ja_hg_intro(inputs)
	return zh_hg_intro(inputs)
};